// AdminEventsPage.jsx
import React, { useState } from "react";
import EventModal from "../components/events/EventModal";
import { createEvent } from "../../controller/c_events";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import TransactionListTable from "../components/transactions/TransactionList";
export const EMPTY_FORM = {
    title: "",
    startDate: "",
    endDate: "",
    duration: "",
    delivery: "",
    isfree: '',
    details: "",
    image: null
};

function validate(form) {
    const e = {};
    if (!form.title.trim()) e.title = "Event title is required.";
    if (!form.startDate) e.startDate = "Start date is required.";
    if (form.endDate && form.startDate && form.endDate < form.startDate) {
        e.endDate = "End date cannot be before start date.";
    }
    return e;
}



export default function ManageTransactions() {
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState();
    const [errors, setErrors] = useState({});
const userid= useSelector((state)=>state.auth.login.userid);

    // const openCreate = () => {
    //     setForm(EMPTY_FORM);
    //     setErrors({});
    //     setOpen(true);
    // };



    const closeModal = () => setOpen(false);

    const submitModal = async () => {
        const v = validate(form);
        setErrors(v);


        const fd = new FormData();
        fd.append("data", JSON.stringify(form));
        Object.entries(form).forEach(([key, value]) => {
            fd.append(key, value);
        });
        const response = await createEvent(fd, userid);
        if (response.state) {
            toast.success(response.message || "Event created successfully.");
        setOpen(false);
        setForm(EMPTY_FORM);
        closeModal();
        return;
        }
        toast.error(response.message || "Failed to create event.");
        
    };


    return (
        <div className="text-light">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h1 className="h3 fw-bold mb-0">Transactions</h1>
            </div>


            <TransactionListTable />

            <EventModal
                open={ open }
                form={ form }
                setForm={ setForm }
                errors={ errors }
                onClose={ closeModal }
                onSubmit={ submitModal }
            />
            
        </div>
    );
}
